// extracted by mini-css-extract-plugin
module.exports = {"button":"B_bj","confirmation":"B_bQ","show":"B_bR"};